var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("viewForm", {
        ref: "viewForm",
        attrs: {
          "is-edit": true,
          "user-id": _vm.userId,
          "user-info": _vm.userInfo,
          "user-all-roles": _vm.userAllRoles,
          "company-lists": _vm.companyLists,
        },
        on: {
          submit: _vm.submit,
          deleteUserRoles: _vm.deleteUserRoles,
          addUserRoles: _vm.addUserRoles,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }